import type { Materials } from '../types/materials';

const black: Materials = [
  {
      id: 0,
      name: "Чорний металолом",
      price: `5.5`,
      category: "black",
      description: "Старі труби, крани, батареї, радіатори, кріплення",
      content: "Компанія 'Металл Сервіс' пропонує вигідні умови прийому чорного металобрухту у Київській області...",
      image: "/metals/chornyj-metalolom.png"
  },
  {
      id: 1,
      name: "Металева стружка",
      price: `2.5`,
      category: "black",
      description: "Металева стружка різних видів",
      content: "Прийом металевої стружки здійснюється у всіх філіях 'Металл Сервіс'...",
      image: "/metals/metaleva-struzhka.png"
  }
];

const color: Materials = [
  {
      id: 5,
      name: "Мідь",
      price: `250`,
      category: "color",
      description: "Мідні вироби та відходи",
      content: "Мідь завжди має високу вартість на ринку металобрухту...",
      image: "/metals/Mid.png"
  },
  {
      id: 6,
      name: "Латунь",
      price: `155`,
      category: "color",
      description: "Латунні вироби та відходи",
      content: "Приймаємо латунні вироби та відходи у будь-якому стані...",
      image: "/metals/Latun.png"
  },
  {
      id: 7,
      name: "Латунний радіатор",
      price: `130`,
      category: "color",
      description: "Радіатори з латуні",
      content: "Латунні радіатори можна вигідно здати у наші пункти прийому...",
      image: "/metals/latunnijradiator.png"
  },
  {
      id: 8,
      name: "Алюміній",
      price: `40`,
      category: "color",
      description: "Алюмінієві вироби та відходи",
      content: "Приймаємо алюміній у будь-якому вигляді...",
      image: "/metals/Aliuminii.png"
  },
  {
      id: 9,
      name: "Алюмінієвий профіль",
      price: `50`,
      category: "color",
      description: "Профілі з алюмінію",
      content: "Алюмінієвий профіль можна вигідно здати у наших пунктах прийому...",
      image: "/metals/aluminiieviiprofil.png"
  },
  {
      id: 10,
      name: "Алюмінієвий електротех",
      price: `55`,
      category: "color",
      description: "Електротехнічний алюміній",
      content: "Приймаємо електротехнічний алюміній будь-якого типу...",
      image: "/metals/aliuminiievyielektrotekh.png"
  },
  {
      id: 11,
      name: "Алюмінієва баночка",
      price: `15`,
      category: "color",
      description: "Алюмінієві баночки",
      content: "Здавайте алюмінієві баночки в 'Металл Сервіс'...",
      image: "/metals/aliuminiievabanochca.png"
  },
  {
      id: 12,
      name: "Алюмінієва фольга",
      price: `15`,
      category: "color",
      description: "Фольга з алюмінію",
      content: "Алюмінієва фольга приймається у будь-якому стані...",
      image: "/metals/aljuminijevafoljgha.png"
  },
  {
      id: 13,
      name: "Алюмінієвий радіатор",
      price: `15`,
      category: "color",
      description: "Радіатори з алюмінію",
      content: "Алюмінієві радіатори — ефективні теплообмінники...",
      image: "/metals/aluminiievyiradiator.png"

  },
  {
      id: 14,
      name: "Свинець",
      price: `25`,
      category: "color",
      description: "Свинець та його сплави",
      content: "Свинець застосовується у виготовленні акумуляторів...",
      image: "/metals/svinets.png"

  },
  {
      id: 15,
      name: "Нержавійка (8%,10%)",
      price: `20`,
      category: "color",
      description: "Нержавіюча сталь з вмістом хрому 8-10%",
      content: "Нержавіюча сталь широко застосовується у харчовій промисловості...",
      image: "/metals/nerzhavijka.png"
  },
  {
      id: 16,
      name: "Радіатор кондиціонера",
      price: `50`,
      category: "color",
      description: "Радіатори кондиціонерів",
      content: "Радіатори кондиціонерів виготовляються зі сплавів алюмінію та міді...",
      image: "/metals/radiatorkondytsionera.png"
  }
];

const special: Materials = [
  {
      id: 2,
      name: "АКБ (Акумулятори) білі",
      price: `16`,
      category: "special",
      description: "Білі акумулятори",
      content: "Білі АКБ — це свинцево-кислотні батареї...",
      image: "/metals/acamuljatori.png"
  },
  {
      id: 3,
      name: "АКБ (Акумулятори) гелеві",
      price: `13`,
      category: "special",
      description: "Гелеві акумулятори",
      content: "Гелеві АКБ використовуються у техніці та транспорті...",
      image: "/metals/acumuliatorihelevi.png"
  },
  {
      id: 4,
      name: "ЦАМ",
      price: `20`,
      category: "special",
      description: "Цинк-алюмінієві сплави",
      content: "ЦАМ - це сплав цинку з алюмінієм, який широко використовується...",
      image: "/metals/tsam.png"
  }
];

const recyclable: Materials = [
  {
      id: 17,
      name: "Макулатура (картон)",
      price: `3`,
      category: "recyclable",
      description: "Картонна макулатура",
      content: "Картонна макулатура використовується для виробництва вторинного паперу...",
       image: "/metals/makulaturakarton.png"
  },
  {
      id: 18,
      name: "Макулатура (біла)",
      price: `3.5`,
      category: "recyclable",
      description: "Біла макулатура",
      content: "Біла макулатура — це високоякісний папір...",
      image: "/metals/makulaturabila.png"
  },
  {
      id: 19,
      name: "Поліетилентерефталат (ПЕТ)",
      price: `3`,
      category: "recyclable",
      description: "ПЕТ пляшки та інші вироби",
      content: "ПЕТ пляшки — основний вид пластикових відходів...",
      image: "/metals/polietylentereftalat-pet.png"
  },
  {
      id: 20,
      name: "Плівка (ВД, стрейтч)",
      price: `6`,
      category: "recyclable",
      description: "Плівка ВД та стрейтч",
      content: "Стрейтч-плівка використовується для пакування...",
      image: "/metals/plivka-vd-strejtch.png"
  },
  {
      id: 21,
      name: "ПВХ",
      price: `8`,
      category: "recyclable",
      description: "Полівінілхлоридні вироби",
      content: "ПВХ використовується для виготовлення труб, віконних профілів...",
      image: "/metals/pvkh.png"
  }
];

export const materials = {
  black,
  color,
  special,
  recyclable
}; 